module.exports = __webpack_public_path__ + "static/media/icon-location.711fe3c3.svg";